import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import api from '../services/api';

/**
 * Where Yuju sends the seller back after they authorise the app.
 *
 * Yuju appends ?code= to the URL it has on file, so this has to be a page and
 * not an API route: the browser arrives on a redirect, with the session in
 * local storage and no way to send a header. The page reads the code and
 * completes the exchange with credentials saved beforehand.
 */
export default function YujuCallback() {
  const navigate = useNavigate();
  const [state, setState] = useState('conectando');
  const [detail, setDetail] = useState('');
  // Codes are single use, and React runs effects twice in development.
  const attempted = useRef(false);

  useEffect(() => {
    if (attempted.current) return;
    attempted.current = true;

    const code = new URLSearchParams(window.location.search).get('code');
    if (!code) {
      setState('error');
      setDetail('Yuju no envió el código de autorización.');
      return;
    }

    (async () => {
      try {
        await api.post('/yuju/connect', { code });
        setState('listo');
        toast.success('Yuju conectado');
        setTimeout(() => navigate('/settings'), 1500);
      } catch (err) {
        setState('error');
        setDetail(err.response?.data?.detail || 'No se pudo completar la conexión.');
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950 px-6">
      <div className="max-w-md w-full bg-slate-900/50 border border-slate-800/50 rounded-2xl p-8 text-center">
        {state === 'conectando' && (
          <>
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mx-auto mb-4" />
            <p className="text-white font-semibold">Conectando con Yuju...</p>
          </>
        )}
        {state === 'listo' && (
          <>
            <p className="text-emerald-400 font-semibold mb-1">Yuju conectado</p>
            <p className="text-sm text-slate-400">Regresando a Configuración...</p>
          </>
        )}
        {state === 'error' && (
          <>
            <p className="text-red-400 font-semibold mb-2">No se pudo conectar</p>
            <p className="text-sm text-slate-400 mb-4">{detail}</p>
            <button
              onClick={() => navigate('/settings')}
              className="px-4 py-2 bg-blue-600 hover:bg-blue-500 text-white rounded-lg text-sm font-medium"
            >
              Volver a Configuración
            </button>
          </>
        )}
      </div>
    </div>
  );
}
